// extracted by mini-css-extract-plugin
module.exports = {"root":"styles_root__mwK33","label":"styles_label__3fWNp"};